import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import i18n from '../../i18n';
import _actions from '../../actions';
import ThirdPartyConnect from './ThirdPartyConnect';
import constants from '../../constants';
import InputDialog from '../common/InputDialog';
import YesNoDialog from '../common/YesNoDialog';

class RSSSermons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpened: false,
        };
    }

    openMediaDialog = () => {
        this.clearMediaAlerts();
        this.setState({
            dialogOpened: true,
            dialogDescription: i18n.t('modules.sermons.rss.description'),
            dialogPlaceholder: i18n.t('modules.sermons.rss.placeholder'),
            dialogTitle: i18n.t('modules.sermons.rss.title'),
            dialogActionName: i18n.t('modules.sermons.rss.action'),
            dialogIconPath: 'M39.0694513,37.2453339 C39.0694513,39.3083472 38.8506469,41.3713605 38.5380691,43.4031159 C38.0692025,46.6539247 37.6003358,49.9985069 36.8188914,53.1868001 C36.2562514,55.4686178 34.1307226,56 32.0677093,56 C30.004696,56 27.8791672,55.4686178 27.3165272,53.1868001 C26.5350828,49.9985069 26.0662162,46.6539247 25.5973495,43.4031159 C25.2847717,41.3713605 25.0659673,39.3083472 25.0659673,37.2453339 C25.0659673,33.025534 28.473065,31.9940274 32.0677093,31.9940274 C35.6623536,31.9940274 39.0694513,33.025534 39.0694513,37.2453339 Z M56.0111663,23.9920365 C56.0111663,34.1195562 49.759611,42.7779604 40.8824024,46.3100892 C40.5385668,46.4351203 40.1634735,46.1225425 40.2259891,45.7474492 C40.3197624,45.0910359 40.4135357,44.4033648 40.5385668,43.6844359 C40.6010824,43.1843115 40.6635979,42.6841871 40.7261135,42.2153204 C40.7573713,42.0277738 40.8511446,41.9027427 41.0074335,41.8402271 C47.5090511,38.5269028 52.0101709,31.775223 52.0101709,23.9920365 C52.0101709,12.582948 42.4452912,3.39316162 30.9111716,4.01831716 C20.346043,4.58095714 11.937701,13.5831969 12.0002166,24.1483254 C12.0627321,31.9315119 16.5951098,38.6519339 23.1279851,41.9027427 C23.284274,41.9652582 23.3780474,42.1215471 23.4093051,42.277836 C23.4718207,42.7154449 23.5343362,43.1843115 23.5968518,43.6844359 C23.7218829,44.4346226 23.8156562,45.1222937 23.9406873,45.8099648 C24.0032029,46.1850581 23.5968518,46.4976358 23.2530162,46.341347 C13.9694565,42.7154449 7.49909673,33.4631429 8.03047894,22.804241 C8.6243767,10.7074814 18.3768031,0.798766147 30.4735627,0.0485795036 C44.4145311,-0.826638247 56.0111663,10.2386147 56.0111663,23.9920365 Z M39.0694513,22.9917877 C39.0694513,26.867752 35.9436736,29.9935297 32.0677093,29.9935297 C28.191745,29.9935297 25.0659673,26.867752 25.0659673,22.9917877 C25.0659673,19.1158234 28.191745,15.9900457 32.0677093,15.9900457 C35.9436736,15.9900457 39.0694513,19.1158234 39.0694513,22.9917877 Z M48.071691,23.9920365 C48.071691,29.1495697 45.6023267,33.7757207 41.8201357,36.6826939 C41.5075579,36.9327561 41.069949,36.7139517 41.0074335,36.3076006 C40.9136601,35.4323829 40.6635979,34.4008762 40.1009579,33.4318851 C39.9759268,33.2443385 40.0071846,32.9942763 40.1947313,32.8067296 C42.5703223,30.6186852 44.0706956,27.4929075 44.0706956,23.9920365 C44.0706956,16.927779 37.9129136,11.2701214 30.6923671,12.0515658 C25.1597406,12.6767213 20.6586208,17.2403568 20.1272386,22.804241 C19.7208875,26.7427209 21.2837763,30.368623 23.9406873,32.8067296 C24.128234,32.9942763 24.1594918,33.2443385 24.0344607,33.4318851 C23.4718207,34.4008762 23.2217585,35.4323829 23.1279851,36.3388584 C23.0654696,36.7139517 22.6278607,36.9327561 22.3152829,36.6826939 C18.4393186,33.6819474 15.9699542,28.9620231 16.0637276,23.648201 C16.2512742,15.3336324 23.002954,8.39440591 31.2862649,8.01931259 C40.4760513,7.58170372 48.071691,14.8960235 48.071691,23.9920365 Z',
            dialogIconFill: 'url(#podcast-a)',
            dialogIconFillRule: 'evenodd',
        });
    };

    importFeedURL = (value) => {
        this.clearMediaAlerts();
        if (!value) {
            this.openAlert();
        } else {
            this.props.updateFields(
                [{ Name: 'mediaType', Value: 3 }, { Name: 'mediaUrl', Value: value.trim() }],
            );
            this.closeDialog();
        }
    };

    openAlert = () => {
        this.props.actions.addAlert({
            id: 'sermons-rss',
            message: i18n.t('modules.sermons.rss.error'),
            dismissable: true,
            type: 'error',
            view: 'modules/sermons',
        });
    };

    clearMediaAlerts = () => {
        this.props.actions.clearAlert('youtube');
        this.props.actions.clearAlert('sermons-rss');
        this.props.actions.clearAlert('sermon-media-invalid');
        this.props.actions.clearAlert('empty');
        this.props.actions.clearAlert('vimeo-denied');
    }

    connectClick = () => {
        if (this.props.versions.select.mediaType) {
            this.showDisconnectConfirm();
        }
        this.openMediaDialog();
    };

    showDisconnectConfirm = () => {
        this.setState({
            confirmDisconnect: true,
        });
    };

    closeDialog = () => {
        this.setState({
            dialogOpened: false,
        });
    };

    closeYesNoDialog = () => {
        this.setState({
            confirmDisconnect: false,
            dialogOpened: false,
        });
    };

    handleDisconnect = () => {
        this.props.handleDisconnect();
        this.setState({
            confirmDisconnect: false,
        });
    };

    render() {
        return (
            <div className="RSS-Sermons">
                {this.state.dialogOpened && !this.state.confirmDisconnect
                    && (
                        <InputDialog
                            AddAlertAction={this.props.actions.addAlert}
                            Alerts={this.props.alerts}
                            Visible={this.state.dialogOpened}
                            Description={this.state.dialogDescription}
                            Title={this.state.dialogTitle}
                            CloseDialog={this.closeDialog}
                            ActionName={this.state.dialogActionName}
                            Action={this.importFeedURL}
                            Placeholder={this.state.dialogPlaceholder}
                            SVGIconPath={this.state.dialogIconPath}
                            SVGIconFill={this.state.dialogIconFill}
                            SVGIconFillRule={this.state.dialogIconFillRule}
                            Value=""
                        />
                    )}
                {this.state.confirmDisconnect
                    && (
                        <YesNoDialog
                            Message={this.props.versions.select.mediaType === constants.MediaType.find((mt) => { return mt.Name === 'Vimeo'; }).Id ? i18n.t('modules.sermons.vimeo.warning') : i18n.t('modules.sermons.confirm')}
                            ExecuteAction={this.handleDisconnect}
                            CloseDialog={this.closeYesNoDialog}
                            Visible={this.state.confirmDisconnect}
                            title="Disconnect Existing Source?"
                        />
                    )}
                <ThirdPartyConnect
                    ThirdPartyId="podcast"
                    ThirdPartyTitle={i18n.t('modules.sermons.rss.header')}
                    ThirdPartyIcon="M12.203 14.628c0 .81-.086 1.621-.209 2.419-.184 1.277-.368 2.59-.675 3.843-.221.896-1.056 1.105-1.866 1.105s-1.645-.21-1.866-1.105c-.307-1.253-.491-2.566-.675-3.843a15.945 15.945 0 0 1-.21-2.419c0-1.657 1.339-2.062 2.75-2.062 1.413 0 2.75.405 2.75 2.062zm6.654-5.205a9.427 9.427 0 0 1-5.942 8.766c-.135.049-.282-.074-.258-.221.037-.258.074-.528.123-.81.024-.197.049-.393.074-.578.012-.073.049-.122.11-.147 2.554-1.301 4.321-3.953 4.321-7.01 0-4.48-3.756-8.09-8.286-7.845-4.15.221-7.452 3.757-7.428 7.906.025 3.057 1.805 5.697 4.37 6.974.062.024.099.086.111.147.025.172.05.356.074.552.049.295.086.565.135.835.024.148-.135.27-.27.209C2.345 16.777-.197 13.143.012 8.957.245 4.205 4.076.314 8.827.019c5.475-.344 10.03 4.002 10.03 9.404zm-6.654-.393a2.745 2.745 0 0 1-2.75 2.75 2.745 2.745 0 0 1-2.75-2.75 2.745 2.745 0 0 1 2.75-2.75 2.745 2.745 0 0 1 2.75 2.75zm3.536.393c0 2.026-.97 3.843-2.456 4.984-.123.099-.294.013-.319-.147a2.863 2.863 0 0 0-.356-1.13c-.05-.073-.037-.171.037-.245a4.688 4.688 0 0 0 1.522-3.462c0-2.774-2.418-4.997-5.254-4.69-2.173.246-3.941 2.038-4.15 4.224a4.665 4.665 0 0 0 1.498 3.928c.074.074.086.172.037.246-.221.38-.32.785-.356 1.141-.025.148-.197.234-.32.135a6.31 6.31 0 0 1-2.455-5.119c.074-3.266 2.726-5.991 5.979-6.138a6.283 6.283 0 0 1 6.593 6.273z"
                    ThirdPartyIconViewBox="0 0 19 22"
                    ThirdPartyFillBox="evenodd"
                    ThirdPartyFill=""
                    Connected={this.props.versions.select.mediaType === constants.MediaType.find((mt) => { return mt.Name === 'RSSPodcast'; }).Id}
                    onClick={() => { this.connectClick(); }}
                    onDisconnect={this.showDisconnectConfirm}
                    Value=""
                    DataQA="rss"
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RSSSermons);
